import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow.down.svg'


const _withScopeId = n => (_pushScopeId("data-v-3bc98b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "whiteBox my-4" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { colspan: "99" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "form-group mb-0" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","right":"2px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "nowrapClass"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","right":"2px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 1,
  class: "form-group mb-0"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "nowrapClass"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","right":"2px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  key: 2,
  class: "form-group mb-0"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "d-flex align-items-center nowrapClass" }
const _hoisted_35 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","right":"2px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { class: "total" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_44 = {
  key: 4,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_45 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_edit_layer_production_process_optional_detailed = _resolveComponent("edit-layer-production-process-optional-detailed")!
  const _component_edit_layer_production_process = _resolveComponent("edit-layer-production-process")!
  const _component_edit_layer_transportation = _resolveComponent("edit-layer-transportation")!
  const _component_layer_water_footprint = _resolveComponent("layer-water-footprint")!
  const _component_view_weastage_data = _resolveComponent("view-weastage-data")!
  const _component_mechanical_embroidery = _resolveComponent("mechanical-embroidery")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showOnlyProcess && _ctx.layerCompositions.length == 0)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              type: "h4",
              localizedKey: "-- No processes or transportation are required for this phase",
              text: "-- No processes or transportation are required for this phase",
              class: "mt-3 mb-5 pb-5"
            }))
          : _createCommentVNode("", true),
        (!_ctx.showOnlyProcess)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.layerCompositions, (layer) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_localized_text, {
                  type: "h3",
                  localizedKey: "Fabric {{layerName}}",
                  text: "Fabric {{layerName}}",
                  object: { layerName: layer.layerName},
                  class: "mb-5"
                }, null, 8, ["object"]),
                (_ctx.layerProductionProcesses[layer.layerName].filter(x => x.productionPhase.text == _ctx.productionPhase && x.emissionCalculation != null && x.emissionCalculation.type != _ctx.liquidPolymerAndTechniqueType).length > 0)
                  ? (_openBlock(), _createBlock(_component_edit_layer_production_process_optional_detailed, {
                      estimationIdentifier: _ctx.estimationIdentifier,
                      layer: layer,
                      countries: _ctx.electricityCountries,
                      allProductionProcesses: _ctx.allProductionProcesses,
                      currentProductionProcesses: _ctx.layerProductionProcesses[layer.layerName].filter(x => x.emissionCalculation != null),
                      productionPhase: _ctx.productionPhase,
                      onInit: _ctx.init,
                      key: layer.layerName + _ctx.productionPhase,
                      class: "mb-5",
                      isReadOnly: _ctx.isReadOnly
                    }, null, 8, ["estimationIdentifier", "layer", "countries", "allProductionProcesses", "currentProductionProcesses", "productionPhase", "onInit", "isReadOnly"]))
                  : (_openBlock(), _createBlock(_component_edit_layer_production_process, {
                      estimationIdentifier: _ctx.estimationIdentifier,
                      layer: layer,
                      countries: _ctx.electricityCountries,
                      allProductionProcesses: _ctx.allProductionProcesses,
                      currentProductionProcesses: _ctx.layerProductionProcesses[layer.layerName],
                      productionPhase: _ctx.productionPhase,
                      isReadOnly: _ctx.isReadOnly,
                      onInit: _ctx.init,
                      key: layer.layerName + _ctx.productionPhase,
                      class: "mb-5",
                      showCopyButtons: _ctx.layerCompositions.length > 1 && _ctx.isUnderwearGament,
                      onCopySectionFromOther: ($event: any) => (_ctx.copyProcessFromOther(layer)),
                      onCopySectionToOther: ($event: any) => (_ctx.copyProcessToOther(layer))
                    }, null, 8, ["estimationIdentifier", "layer", "countries", "allProductionProcesses", "currentProductionProcesses", "productionPhase", "isReadOnly", "onInit", "showCopyButtons", "onCopySectionFromOther", "onCopySectionToOther"])),
                (_openBlock(), _createBlock(_component_edit_layer_transportation, {
                  estimationIdentifier: _ctx.estimationIdentifier,
                  countries: _ctx.electricityCountries,
                  transportDistanceCalculation: _ctx.transportationCountries,
                  layer: layer,
                  currentTransportation: _ctx.layerTransportPhases[layer.layerName],
                  productionPhase: _ctx.productionPhase,
                  saveCallback: _ctx.saveTransportationCallback,
                  removeCallback: _ctx.removeCallback,
                  onInit: _ctx.init,
                  key: layer.layerName + _ctx.productionPhase,
                  class: "pb-4",
                  isReadOnly: _ctx.isReadOnly,
                  showCopyButtons: _ctx.layerCompositions.length > 1 && _ctx.isUnderwearGament,
                  onCopySectionFromOther: ($event: any) => (_ctx.copyTransportFromOther(layer)),
                  onCopySectionToOther: ($event: any) => (_ctx.copyTransportToOther(layer))
                }, null, 8, ["estimationIdentifier", "countries", "transportDistanceCalculation", "layer", "currentTransportation", "productionPhase", "saveCallback", "removeCallback", "onInit", "isReadOnly", "showCopyButtons", "onCopySectionFromOther", "onCopySectionToOther"])),
                (_ctx.waterFootprints[layer.layerName] ? _ctx.waterFootprints[layer.layerName].filter(x => x.productionPhase.text == _ctx.productionPhase).length > 0 : false)
                  ? (_openBlock(), _createBlock(_component_layer_water_footprint, {
                      key: 2,
                      productionPhase: _ctx.productionPhase,
                      currentWaterFootprints: _ctx.waterFootprints[layer.layerName],
                      class: "pb-3"
                    }, null, 8, ["productionPhase", "currentWaterFootprints"]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          : _createCommentVNode("", true),
        _createVNode(_component_view_weastage_data, {
          allProductionProcesses: _ctx.layerProductionProcesses,
          productionPhase: _ctx.productionPhase,
          layers: _ctx.layerCompositions
        }, null, 8, ["allProductionProcesses", "productionPhase", "layers"]),
        (_ctx.indipendentProductionProcess.length > 0 && 
                (_ctx.productionPhase.includes('Manufacturing')))
          ? (_openBlock(), _createBlock(_component_mechanical_embroidery, {
              key: 2,
              estimationIdentifier: _ctx.estimationIdentifier,
              isReadOnly: _ctx.isReadOnly
            }, null, 8, ["estimationIdentifier", "isReadOnly"]))
          : _createCommentVNode("", true),
        (_ctx.indipendentProductionProcess.length > 0 && 
                (_ctx.productionPhase.includes('Manufacturing')) ||
                _ctx.productionPhase.includes('Finishing'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(_ctx.showOnlyProcess ? '' : 'mt-5')
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_localized_text, {
                  type: "h3",
                  localizedKey: "Additional Material",
                  text: "Additional Material"
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("table", _hoisted_5, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Production Group",
                            text: "Production Group"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Process Name",
                            text: "Process Name"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "CO2e",
                            text: "CO2e"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Production Country",
                            text: "Production Country"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Value",
                            text: "Value"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_ctx.indipendentProductionProcess.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                            _createElementVNode("td", _hoisted_7, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "No Elements Found",
                                text: "No Elements Found"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indipendentProductionProcess, (item, indice) => {
                        return (_openBlock(), _createElementBlock("tr", { key: indice }, [
                          _createElementVNode("td", null, [
                            (item.productionGroup)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.productionGroup), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
                          ]),
                          _createElementVNode("td", _hoisted_10, [
                            (item.isUnique && !item.wristBand && !item.reflectiveBands && !_ctx.isReadOnly)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "position-relative form-control d-flex align-items-center pointer pe-4",
                                  onClick: ($event: any) => (_ctx.editAdditionalLayerProductionProcess(item))
                                }, [
                                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                  _hoisted_12
                                ], 8, _hoisted_11))
                              : (item.wristBand)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Knit band",
                                      text: "Knit band"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.name), 1))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(item.cO2e)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              (item.productionCountry.text)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.productionCountry.text), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item.wristBand)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (!_ctx.isReadOnly)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "position-relative form-control d-flex align-items-center pointer pe-4",
                                        onClick: ($event: any) => (_ctx.editKnitBand(item))
                                      }, [
                                        (item.units > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.knitBandSummary(item.wristBand)), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                              _createVNode(_component_localized_text, {
                                                localizedKey: "Knit band information missing. Click here",
                                                text: "Knit band information missing. Click here"
                                              })
                                            ])),
                                        _hoisted_21
                                      ], 8, _hoisted_18))
                                    : (item.units > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.knitBandSummary(item.wristBand)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, "--"))
                                ]))
                              : (item.reflectiveBands)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (!_ctx.isReadOnly)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "position-relative form-control d-flex align-items-center pointer pe-4",
                                          onClick: ($event: any) => (_ctx.editReflectiveBands(item))
                                        }, [
                                          (item.units > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.reflectiveBands.code) + " — " + _toDisplayString(item.reflectiveBands.description), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                                _createVNode(_component_localized_text, {
                                                  localizedKey: "Reflective Bands information missing. Click here",
                                                  text: "Reflective Bands information missing. Click here"
                                                })
                                              ])),
                                          _hoisted_28
                                        ], 8, _hoisted_25))
                                      : (item.units > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.reflectiveBands.code) + " — " + _toDisplayString(item.reflectiveBands.description), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_30, "--"))
                                  ]))
                                : (item.isLengthDependent)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      (!_ctx.isReadOnly)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "position-relative form-control d-flex align-items-center pointer pe-4",
                                            onClick: ($event: any) => (_ctx.editLengthDependentProductionProcess(item))
                                          }, [
                                            (item.width > 0 && item.thickness > 0 && item.density > 0 && item.length > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                  _createElementVNode("span", _hoisted_34, [
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Width:",
                                                      text: "Width:",
                                                      class: "me-1"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(item.width) + " (cm), ", 1),
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Thickness:",
                                                      text: "Thickness:",
                                                      class: "mx-1"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(item.thickness) + " (cm), ", 1),
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Density:",
                                                      text: "Density:",
                                                      class: "mx-1"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(item.thickness) + " (g/cm3) ", 1),
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Length:",
                                                      text: "Length:",
                                                      class: "mx-1"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(item.length) + " (cm) ", 1)
                                                  ])
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                                  _createVNode(_component_localized_text, {
                                                    localizedKey: "informations missing. Click here",
                                                    text: "informations missing. Click here",
                                                    class: "ms-1"
                                                  })
                                                ])),
                                            _hoisted_36
                                          ], 8, _hoisted_32))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.name), 1))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      (_ctx.editEstimationLayerProductionProcessList[indice])
                                        ? (_openBlock(), _createBlock(_component_form_field, {
                                            key: 0,
                                            type: "number",
                                            placeholderKey: "Value",
                                            placeholderValue: "Value",
                                            min: "0",
                                            modelValue: _ctx.editEstimationLayerProductionProcessList[indice].units,
                                            "onUpdate:modelValue": [($event: any) => ((_ctx.editEstimationLayerProductionProcessList[indice].units) = $event), ($event: any) => (_ctx.updateValue(indice))],
                                            readonly: _ctx.isReadOnly
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                                        : (_openBlock(), _createBlock(_component_localized_text, {
                                            key: 1,
                                            localizedKey: "--Not exists anymore on our software",
                                            text: "--Not exists anymore on our software",
                                            class: "fs_12"
                                          }))
                                    ]))
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_39, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Total",
                              text: "Total"
                            })
                          ])
                        ]),
                        _hoisted_40,
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("cO2e", _ctx.indipendentProductionProcess))), 1)
                        ]),
                        _hoisted_41,
                        (_ctx.indipendentProductionProcess.some(x => !x.isElectricityEmissionIndipendent))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_42))
                          : _createCommentVNode("", true),
                        _hoisted_43
                      ])
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "btn btn-secondary me-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Previous",
                  text: "Previous"
                })
              ]),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
                disabled: _ctx.disabled
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ], 8, _hoisted_45)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}